import React, { useState, useEffect } from "react";
import {
    Button,
    Modal,
    Typography,
    IconButton,
    Grid,
    TextField,
} from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";
import axios from "axios";
import styles from "./ImageUploaderModal.module.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const ImageUploaderModal = ({ imagesArr, roomTypeId }) => {
    const [isOpen, setModalOpen] = useState(false);
    const [images, setImages] = useState(
        imagesArr
            ?.sort((a, b) => a.order - b.order)
            ?.map((image) => ({ url: image.link, fromServer: true })),
    );
    const [errors, setErrors] = useState([]);

    const refreshImages = () => {
        axios
            .get(`/manager/data/room_types/${roomTypeId}/get_images`)
            .then((response) => {
                setImages(
                    response.data
                        ?.sort((a, b) => a.order - b.order)
                        ?.map((image) => ({
                            url: image.link,
                            fromServer: true,
                        })),
                );
            });
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const newImages = [];
        const newErrors = [];

        files.forEach((file) => {
            const fileType = file.type.split("/")[1];
            if (!["jpeg", "jpg", "png", "webp"].includes(fileType)) {
                newErrors.push(`Формат файла ${file.name} не поддерживается.`);
                return;
            }
            if (file.size > 1024 * 1024) {
                newErrors.push(`Размер файла ${file.name} превышает 1МБ.`);
                return;
            }
            newImages.push({
                file,
                url: URL.createObjectURL(file),
                order: images.length + newImages.length + 1,
            });
        });

        setErrors(newErrors);
        setImages((prev) => [...prev, ...newImages]);
    };

    const handleDeleteImage = (index) => {
        setImages(images.filter((_, i) => i !== index));
    };

    const handleSave = async () => {
        const formData = new FormData();
        images.forEach((image, index) => {
            if (image.file) {
                formData.append(`images[${index}]`, image.file);
            } else {
                formData.append(`images[${index}]`, image.url);
            }
        });
        try {
            const response = await axios.post(
                `/manager/data/room_types/${roomTypeId}/upload_images`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                },
            );
            handleCloseModal(false);
        } catch (error) {
            setErrors(["Произошла ошибка при загрузке. Попробуйте снова."]);
        }
    };

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = (needUpdate = true) => {
        if (needUpdate) {
            refreshImages();
        }
        setModalOpen(false);
    };

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const updatedImages = [...images];
        const [reorderedItem] = updatedImages.splice(result.source.index, 1);
        updatedImages.splice(result.destination.index, 0, reorderedItem);

        setImages(
            updatedImages.map((img, index) => ({ ...img, order: index + 1 })),
        );
    };

    return (
        <div>
            <Button
                variant="contained"
                color="primary"
                onClick={handleOpenModal}
            >
                Загрузить изображения
            </Button>

            <Modal
                open={isOpen}
                onClose={handleCloseModal}
                className={styles.modal}
            >
                <div className={styles.paper}>
                    {errors.length > 0 && (
                        <Typography className={styles.errorMessages}>
                            {errors.map((error, index) => (
                                <div key={index}>{error}</div>
                            ))}
                        </Typography>
                    )}

                    <input
                        accept="image/jpeg,image/png,image/webp"
                        className={styles.hiddenInput}
                        id="image-uploader"
                        multiple
                        type="file"
                        onChange={handleFileChange}
                    />
                    <label htmlFor="image-uploader">
                        <Button
                            className={styles.bottonBlack}
                            variant="contained"
                            color="primary"
                            component="span"
                        >
                            Выбрать изображения
                        </Button>
                    </label>

                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="images">
                            {(provided) => (
                                <Grid
                                    container
                                    spacing={2}
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    {images.map((image, index) => (
                                        <Draggable
                                            key={index}
                                            draggableId={String(index)}
                                            index={index}
                                        >
                                            {(provided) => (
                                                <Grid
                                                    item
                                                    xs={2}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                >
                                                    <div
                                                        className={
                                                            styles.imageGrid
                                                        }
                                                    >
                                                        <div>
                                                            <img
                                                                src={image.url}
                                                                alt="thumbnail"
                                                                className={
                                                                    styles.thumbnail
                                                                }
                                                            />
                                                            <div>
                                                                <p
                                                                    className={
                                                                        styles.name__images
                                                                    }
                                                                >
                                                                    {image?.fromServer
                                                                        ? image.url
                                                                              .split(
                                                                                  "/",
                                                                              )
                                                                              .pop()
                                                                        : image
                                                                              ?.file
                                                                              ?.name}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <TextField
                                                            label={index}
                                                            disabled={true}
                                                            onChange={(e) => {
                                                                const newOrder =
                                                                    e.target
                                                                        .value;
                                                                setImages(
                                                                    (
                                                                        prevImages,
                                                                    ) => {
                                                                        const updatedImages =
                                                                            [
                                                                                ...prevImages,
                                                                            ];
                                                                        updatedImages[
                                                                            index
                                                                        ].order =
                                                                            newOrder;
                                                                        return updatedImages;
                                                                    },
                                                                );
                                                            }}
                                                        />

                                                        <IconButton
                                                            onClick={() =>
                                                                handleDeleteImage(
                                                                    index,
                                                                )
                                                            }
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </div>
                                                </Grid>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </Grid>
                            )}
                        </Droppable>
                    </DragDropContext>

                    <div className={styles.buttonsWrapper}>
                        <Button variant="contained" onClick={handleCloseModal}>
                            Назад
                        </Button>
                        <Button
                            variant="contained"
                            className={styles.bottonBlack}
                            color="primary"
                            onClick={handleSave}
                        >
                            Сохранить
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ImageUploaderModal;
